import React from 'react';
import MotionDiv from './motion';

const Layout = ({ children }) => {

  return (
    <div className="flex flex-col min-h-screen text-black dark:text-white w-full sm:w-3/4">

      {/* Main Content */}
      <div className="flex-1 flex flex-col">

        {/* Children (75% av utrymmet) */}
        <div className="flex-grow-[3] p-4 sm:p-8 content-center">
          <MotionDiv>
            {children}
          </MotionDiv>
        </div>
      </div>
    </div>
  );
};

export default Layout;